/**
 * Configuracion unificada de DamyxIA
 * Re-exporta desde config/api.js como unica fuente de verdad.
 *
 * API_URL = URL base (ej: https://damyxia.com)
 * API     = URL base + /api (ej: https://damyxia.com/api)
 */

import { BACKEND_URL, API_URL as UNIFIED_API_URL, getBackendUrl } from './config/api';

export const API_URL = BACKEND_URL;
export const API = UNIFIED_API_URL;

export { getBackendUrl };

export default {
  API_URL: BACKEND_URL,
  API: UNIFIED_API_URL,
  getBackendUrl
};
